<div
  class="flex items-center justify-between rounded-b-md border-t border-gray-200 bg-white px-4 py-3 sm:px-6"
>
  <div class="hidden text-sm sm:flex sm:flex-1 sm:items-center sm:justify-between">
    <p class="text-sm leading-5 text-gray-700">
      <select
        name="pagesize"
        [ngModel]="selectedPageSize()"
        (ngModelChange)="selectedPageSize.set(+$event); sizeChanged()"
        class="mx-2 rounded-md border-gray-400 text-sm focus:outline-hidden"
      >
        <option value="10">10</option>
        <option value="25">25</option>
        <option value="50">50</option>
        <option value="100">100</option>
        <option value="500">500</option>
      </select>
      <span class="text-gray-500">Showing {{ totalResultsSize() }} results</span>
    </p>

    <span class="text-xs text-gray-500">Page {{ pageNumber() + 1 }}</span>
    <nav class="relative z-0 inline-flex shadow-xs">
      <button
        aria-label="Previous"
        (click)="onPrev()"
        [disabled]="pageNumber() <= 0"
        class="focus:shadow-outline-blue relative inline-flex items-center rounded-l-md border border-gray-300 bg-white px-2 py-2 text-xs leading-5 font-medium text-gray-500 transition duration-150 ease-in-out hover:text-gray-400 focus:z-10 focus:border-blue-300 focus:outline-hidden active:bg-gray-100 active:text-gray-500 disabled:cursor-not-allowed disabled:bg-gray-100 disabled:text-gray-400"
      >
        <i class="fas fa-chevron-left mr-2"></i>
        Previous
      </button>
      <button
        aria-label="Next"
        (click)="onNext()"
        [disabled]="isNextDisabled()"
        class="focus:shadow-outline-blue relative -ml-px inline-flex items-center rounded-r-md border border-gray-300 bg-white px-2 py-2 text-xs leading-5 font-medium text-gray-500 transition duration-150 ease-in-out hover:text-gray-400 focus:z-10 focus:border-blue-300 focus:outline-hidden active:bg-gray-100 active:text-gray-500 disabled:cursor-not-allowed disabled:bg-gray-100 disabled:text-gray-400"
      >
        Next
        <i class="fas fa-chevron-right ml-2"></i>
      </button>
    </nav>
  </div>
</div>
